
export const calculateLuminance = ({ r, g, b }: {
    r: number;
    g: number;
    b: number;
}): number => {
    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    return luminance;
}